import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"name":_vm.validateName,"attribute":`fields.${_vm.validateName}`},scopedSlots:_vm._u([{key:"default",fn:function({ attrs }){return [_c(VTextarea,_vm._b({attrs:{"rows":_vm.rows,"outlined":"","no-resize":""},on:{"keyup":_vm.active},model:{value:(_vm.getModelValue),callback:function ($$v) {_vm.getModelValue=$$v},expression:"getModelValue"}},'v-textarea',attrs,false))]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }